<script setup>
import InlineSvg from "@/features/InlineSvg.vue";

defineEmits(["input"]);
</script>

<template>
  <label
    class="app-form-radio"
    :class="{
      'app-form-radio--error': $attrs.error,
    }"
  >
    <input
      :checked="$attrs.value === $attrs.id"
      v-bind="$attrs"
      type="radio"
      class="app-form-radio__input"
      @input="$emit('input', $attrs.id)"
    />
    <InlineSvg
      name="radio-active"
      class="app-form-radio__icon app-form-radio__icon--checked"
    />
    <InlineSvg
      name="radio-inactive"
      class="app-form-radio__icon app-form-radio__icon--unchecked"
    />
    <span class="app-form-radio__label">
      <slot />
    </span>
  </label>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.app-form-radio {
  width: 100%;
  padding: 18px 16px;
  border-radius: 10px;
  border: 1px solid $color-primary-30;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;

  @media (width >= 700px) {
    padding: 28px 20px;
  }

  &:hover {
    border: 1px solid $color-primary-50;
  }

  &:has(.app-form-radio__input:focus) {
    outline: 2px solid $color-primary-100;
  }

  &:has(.app-form-radio__input:disabled) {
    border: 1px solid $color-primary-30;
    background-color: $color-primary-5;
    cursor: not-allowed;
  }

  &:has(.app-form-radio__input:checked) {
    outline: 2px solid $color-primary-100;

    &:hover {
      outline: 2px solid $color-primary-100;
    }
  }

  &--error {
    border: 1px solid $color-alert;
  }

  &__icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: $color-primary-100;

    &--checked {
      display: none;

      @at-root .app-form-radio__input:checked ~ & {
        display: block;
      }
    }

    &--unchecked {
      @at-root .app-form-radio__input:checked ~ & {
        display: none;
      }
    }
  }

  &__input {
    position: absolute;
  }

  &__label {
    color: $color-primary-100;
    font-family: $global-font;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 15px;

    @at-root .app-form-radio__input:checked ~ & {
      font-weight: 600;
    }
  }
}
</style>
